import {Directive, Inject, TemplateRef} from '@angular/core';
import {DIALOG_CONFIG, DialogConfig} from '../ac-dialog.models';


@Directive({selector: '[ac-dialog-additional-actions], [acDialogAdditionalActions]'})
export class AcDialogAdditionalActionsDirective {

    constructor(
        @Inject(DIALOG_CONFIG) public dialogConfig: DialogConfig,
        private templateRef: TemplateRef<any>,
    ) {
        dialogConfig.additionalActionsTemplate = templateRef;
    }
}
